const steps = [
  {
    num: "01",
    icon: "ri-file-list-3-line",
    title: "Devis en ligne",
    desc: "Remplissez notre formulaire en 2 minutes. Recevez votre devis personnalisé immédiatement par email.",
  },
  {
    num: "02",
    icon: "ri-calendar-check-line",
    title: "Choix du créneau",
    desc: "Sélectionnez le créneau qui vous convient. Intervention disponible sous 48h dans toute l'Île-de-France.",
  },
  {
    num: "03",
    icon: "ri-user-star-line",
    title: "Intervention",
    desc: "Notre diagnostiqueur certifié COFRAC se déplace à votre adresse à l'heure convenue.",
  },
  {
    num: "04",
    icon: "ri-file-check-line",
    title: "Rapport le jour même",
    desc: "Vous recevez votre rapport complet et certifié par email le jour même de l'intervention.",
  },
];

export default function HowItWorks() {
  return (
    <section className="bg-white py-24">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <span className="inline-block bg-blue-50 text-[#0F3B5F] text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-4">
            Notre processus
          </span>
          <h2 className="text-4xl font-extrabold text-[#0F3B5F] mb-4" style={{ fontFamily: "Barlow, sans-serif" }}>
            Comment ça marche ?
          </h2>
          <p className="text-lg text-gray-500 max-w-xl mx-auto">
            Un processus simple et rapide pour obtenir vos diagnostics immobiliers en toute sérénité.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 relative">
          {/* Connector line desktop */}
          <div className="hidden lg:block absolute top-10 left-[12.5%] right-[12.5%] h-0.5 border-t-2 border-dashed border-orange-200 z-0"></div>

          {steps.map((step, i) => (
            <div key={step.num} className="relative z-10 flex flex-col items-center text-center group">
              {/* Circle */}
              <div className="w-20 h-20 flex items-center justify-center rounded-full border-3 border-[#F97316] bg-white mb-5 group-hover:bg-[#F97316] transition-all duration-300 relative">
                <span className="text-2xl font-extrabold text-[#F97316] group-hover:hidden" style={{ fontFamily: "Barlow, sans-serif" }}>
                  {step.num}
                </span>
                <i className={`${step.icon} text-2xl text-white hidden group-hover:block`}></i>
              </div>
              <h3 className="text-lg font-bold text-[#0F3B5F] mb-2" style={{ fontFamily: "Barlow, sans-serif" }}>{step.title}</h3>
              <p className="text-sm text-gray-500 leading-relaxed">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
